
//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getRidingPeriod, getLivraison } from "../../../../store/selectors.js"; //global state : shopping state
import { shoppingStepSlice } from "../../../../store/shoppingStepSlice.js";
import { contratStepSlice } from "../../../../store/contratStepSlice.js";

//MUI Components
import Button from '@mui/material/Button';

// utils function to get duration object
import calculDuree from '../../../../utils/calcul_duree.js'

//Translate utils :
import { translator } from "../../../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

//Button to validate the period and location
function ButtonValidStep1({ idSpot }) {
    const dispatch = useDispatch();
    const period = useSelector(getRidingPeriod) //global state : shopping step
    const livraison = useSelector(getLivraison); //global state : id of the selected spot
    const infoMissing = !livraison.valid;
    const lang = useSelector(getLang) //global state : language
    //console.log(livraison);

    let tooShort = false;
    let duration = calculDuree(period); // get number of days, weeks, hours...
    tooShort = (duration.semaine === 0 && duration.bimensuel === 0 && duration.jour < 3);
    const dsbld = (period[1][0] === 0 || period[1][1] === 0 || (idSpot === 99 && tooShort) || (idSpot === 99 && infoMissing));

    const nextStep = (event) => {
        dispatch(shoppingStepSlice.actions.nextShoppingStep());
        ///Manager mode
        dispatch(contratStepSlice.actions.nextContratStep());
    }
    return (
        <div className="btn-valid-step-1">
            <Button
                disabled={dsbld}
                variant="contained"
                onClick={nextStep}
                className="bt-valid" //stylise in css
            >{translator("Choisissez vos vélos", lang, "BtValidStep1")}</Button>
        </div>

    )
}




export default ButtonValidStep1